import React from 'react';
import PropTypes from 'prop-types';

import Modal from './Modal';
import Button from '../button/Button';
import PrimaryButton from '../button/PrimaryButton';
import CartProduct from '../cartProduct/CartProduct';
import ProductVariantContainer from '../productVariants/ProductVariantContainer';
import {FormattedMessage} from 'react-intl';

export default function CartModal({cart, onClose, onRemove, onCheckout, ...rest}) {
  const items = cart ? cart.items : [];

  return (
    <Modal type="cart" onClose={onClose} {...rest}>
      <div className="modal__header">
        <FormattedMessage id="section.cart.title" />
      </div>

      {items.length ? (
        <div className="cart-product-list">
          {items.map((item) => (
            <CartProduct
              key={item.id}
              id={item.id}
              image={item.variant.product.images[0]}
              name={CartProduct.getItemTitle(item, cart.createdFromAdmin)}
              eventOccurrence={item.event && item.eventOccurrence}
              options={ProductVariantContainer.describeProductChoice(item)}
              price={item.total}
              onRemoveClick={onRemove}
              modal
            />
          ))}
        </div>
      ) : (
        <div className="modal__notice">
          <p className="modal__text">
            <FormattedMessage id="section.cart.empty" />
          </p>
        </div>
      )}

      <div className="modal__btns">
        <Button full onClick={onClose}>
          <FormattedMessage id="section.cart.continue" />
        </Button>
        {!!items.length && (
          <PrimaryButton full onClick={onCheckout}>
            <FormattedMessage id="section.cart.checkout" />
          </PrimaryButton>
        )}
      </div>
    </Modal>
  );
}

CartModal.propTypes = {
  cart: PropTypes.object,
  onClose: PropTypes.func,
  onRemove: PropTypes.func,
  onCheckout: PropTypes.func
};



// WEBPACK FOOTER //
// ./components/modals/CartModal.js